// Lecture du RÉSUMÉ PARTAGÉ d'une analyse TURPE (backend utils/turpeAnalyseResume.js, joint par
// GET /api/turpe/get-analysis-summary sous `resume`). Verdict du conseil du 24/10/2026 :
// `version_of_use_saving_eur` n'est plus lu ; l'économie de version, le total et le statut
// (concluant / non concluant / non vérifié) viennent UNIQUEMENT du résumé.

/** Économie de version retenue (null = non mesurée, surcoût ou analyse non concluante). */
export const economieVersionDuResume = (summary) => summary?.resume?.fta?.economie_eur ?? null;

/** Total validé (null tant que l'analyse n'est pas concluante). */
export const totalDuResume = (summary) => summary?.resume?.economie_totale_eur ?? null;

/** true seulement si le résumé dit l'analyse concluante. */
export const estConcluante = (summary) => summary?.resume?.statut === 'concluant';

/** Libellé court + motifs d'un statut non concluant. */
export function motifConclusion(resume) {
  if (!resume || resume.statut === 'concluant') return null;
  const titre = resume.statut === 'non_verifie' ? 'Analyse non vérifiée' : 'Analyse non concluante';
  return { titre, motifs: resume.motifs || [] };
}

/**
 * Ce qu'on enregistre d'une analyse de version d'utilisation (update-analysis-result,
 * version_of_use_details_json). Avant le 24/10/2026, deux écrans perdaient la version
 * actuelle et les coûts par version (17 analyses sur 35 en prod), et recalculaient la
 * recommandation en CU/LU seulement (MU ignorée). On garde tout ce que le moteur rend :
 * version actuelle, coûts par version, recommandation, puissance de calcul, conclusion.
 */
export function versionPourSauvegarde(resultatMoteur) {
  const fin = resultatMoteur?.financial_analysis || {};
  return {
    economie_annuelle: fin.economie_annuelle ?? null, // historique, plus lu pour l'affichage
    cout_cu: fin.cout_annuel_cu ?? null,
    cout_lu: fin.cout_annuel_lu ?? null,
    cout_mu: fin.cout_annuel_mu ?? null,
    couts_par_version: fin.couts_par_version || null,
    current_version: resultatMoteur?.current_version || null,
    recommended_version: resultatMoteur?.recommended_version || null,
    ps_calcul: resultatMoteur?.['ps_optim_appliquée'] || null,
    conclusion: resultatMoteur?.conclusion || null,
  };
}

/**
 * Motif de blocage de la page (null si l'analyse est concluante ou sans résumé) : analyse non
 * concluante OU non vérifiée → aucun montant ni recommandation, choix final et PDF désactivés.
 */
export function motifBlocage(summary) {
  const m = motifConclusion(summary?.resume);
  return m ? `${m.titre} : ${m.motifs.join(' ')}`.trim() : null;
}
